module.exports = __webpack_public_path__ + "img/works_kdb_btm_off.d4691d23.jpg";